import React, {useImperativeHandle} from "react";
import {Space, Form, Row, Col, Button, message} from "antd";

const Child = React.forwardRef((props, ref) => {
  const data = {name: "TD411"};
  useImperativeHandle(ref, () => ({
    getData: () => {
      return data;
    },
  }));
  return (
    <div className="child">
      <div style={{fontWeight: 600, textAlign: "center"}}>Child</div>
      <Space direction="vertical">
        <div>{data.name}</div>
      </Space>
    </div>
  );
});
export default Child;
